module.exports = [
 {
  "start": 125,
  "end": 3333,
  "text": "Pipi, thank you so much for talking to us."
 },
 {
  "start": 3375,
  "end": 4500,
  "text": "Yeah, thank you."
 },
 {
  "start": 4583,
  "end": 6166,
  "text": "Thank you for your super questions. "
 },
 {
  "start": 8083,
  "end": 11291,
  "text": "To begin with, Pipi, your work has been "
 },
 {
  "start": 11417,
  "end": 14166,
  "text": "described as \"willfully chaotic.\""
 },
 {
  "start": 14458,
  "end": 17708,
  "text": "To us, that taps into your use of colours, "
 },
 {
  "start": 17834,
  "end": 22583,
  "text": "light, and sound in these incredibly immersive environments."
 },
 {
  "start": 23166,
  "end": 26625,
  "text": "Would you use \"chaos\" to describe your work, "
 },
 {
  "start": 26792,
  "end": 29500,
  "text": "or is there a better way to explain "
 },
 {
  "start": 29500,
  "end": 32208,
  "text": "this joyful experience for visitors?"
 },
 {
  "start": 33583,
  "end": 36667,
  "text": "I like the word \"chaos.\" "
 },
 {
  "start": 38625,
  "end": 44208,
  "text": "I wanna be strong enough to endure chaos, "
 },
 {
  "start": 44458,
  "end": 49959,
  "text": "and I'm suspicious of the notion of linearity. "
 },
 {
  "start": 50458,
  "end": 55000,
  "text": "And also I'm suspicious of a moral superiority ... "
 },
 {
  "start": 55041,
  "end": 56625,
  "text": "How you say? Superiority?"
 },
 {
  "start": 56667,
  "end": 58000,
  "text": "Superiority, yeah."
 },
 {
  "start": 59917,
  "end": 62208,
  "text": "Superiority, that often includes "
 },
 {
  "start": 62208,
  "end": 63959,
  "text": "an illusion of an order, "
 },
 {
  "start": 65083,
  "end": 67458,
  "text": "like religions or ideologies "
 },
 {
  "start": 67458,
  "end": 69667,
  "text": "try to make us believe in. "
 },
 {
  "start": 70000,
  "end": 72291,
  "text": "So life is chaos."
 },
 {
  "start": 72792,
  "end": 73917,
  "text": "That's true."
 },
 {
  "start": 74041,
  "end": 76959,
  "text": "Is that what you're trying to capture in your work, "
 },
 {
  "start": 77500,
  "end": 79250,
  "text": "this everyday chaos?"
 },
 {
  "start": 80000,
  "end": 86166,
  "text": "that's a good notion. "
 },
 {
  "start": 86250,
  "end": 90083,
  "text": "Chaos is often negative connotated, "
 },
 {
  "start": 90208,
  "end": 94542,
  "text": "and I would like to embrace chaos "
 },
 {
  "start": 94834,
  "end": 101166,
  "text": "and to be strong enough to see the beauty in the chaos."
 },
 {
  "start": 101458,
  "end": 105041,
  "text": "I guess it's hard to find that strength though. "
 },
 {
  "start": 105208,
  "end": 109208,
  "text": "How do you find strength to see beautify in chaos?"
 },
 {
  "start": 110208,
  "end": 112875,
  "text": "To accept contradictions. "
 },
 {
  "start": 113250,
  "end": 118291,
  "text": "To not always jump to the easiest answer."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room10/audio1/10_conversation_srt.js